import {
  createContext,
  ReactNode,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { UserService } from 'services';
import { UserStateProps } from 'types';
import { IUserRole } from 'types/Auth';

type UserProviderProps = {
  children: ReactNode;
};

export interface IUserContext {
  user: UserStateProps;
  getUser: () => void;
  role: IUserRole;
  isAdmin: boolean;
  isPartner: boolean;
  isVet: boolean;
  isTutor: boolean;
}

export const UserContext = createContext<IUserContext>({} as IUserContext);

export const UserProvider = ({ children }: UserProviderProps) => {
  const [user, setUser] = useState<UserStateProps>({} as UserStateProps);
  const role = localStorage.getItem('role') as IUserRole;

  const isAdmin = useMemo(() => role === 'admin', [role]);
  const isPartner = useMemo(() => role === 'partner', [role]);
  const isVet = useMemo(() => role === 'vet', [role]);
  const isTutor = useMemo(() => role === 'tutor', [role]);

  const getUser = useCallback(() => {
    UserService.getCurrentUser().then((response) => {
      if (response.status === 200) {
        setUser({ ...response.data, role });
      }
    });
  }, [role]);

  useEffect(() => {
    getUser();
  }, [getUser]);

  return (
    <UserContext.Provider
      value={{
        user,
        getUser,
        role,
        isAdmin,
        isPartner,
        isVet,
        isTutor,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
